export default "__VITE_ASSET__DJQYdQsZ__"